<template>
  <span>{{time}}</span>
</template>
<script>
  import moment from 'moment-timezone';

  export default {
    name: 'CurrentTime',
    props: ['timezone'],
    data() {
      return {
        time: moment().tz(this.timezone).format('hh:mm:ss a'),
      };
    },
    mounted() {
      this.interval = setInterval(() => {
        this.time = moment().tz(this.timezone).format('hh:mm:ss a');
      }, 1000);
    },
    beforeDestroy() {
      clearInterval(this.interval);
    },
  };
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/CurrentTime.vue